"use client";

import { type ReactNode, createContext, useRef, useContext } from "react";
import { useStore } from "zustand";

import {
  type HotelStore,
  createHotelStore,
} from "@/stores/hotel-store/HotelStore";

export type HotelStoreApi = ReturnType<typeof createHotelStore>;

export const HotelStoreContext = createContext<HotelStoreApi | undefined>(
  undefined,
);

export interface HotelStoreProviderProps {
  children: ReactNode;
}

export const HotelStoreProvider = ({ children }: HotelStoreProviderProps) => {
  const storeRef = useRef<HotelStoreApi | null>(null);
  if (!storeRef.current) {
    storeRef.current = createHotelStore();
  }

  return (
    <HotelStoreContext.Provider value={storeRef.current}>
      {children}
    </HotelStoreContext.Provider>
  );
};

export const useHotelStore = <T,>(selector: (store: HotelStore) => T): T => {
  const hotelStoreContext = useContext(HotelStoreContext);

  if (!hotelStoreContext) {
    throw new Error("useHotelStore must be used within CounterStoreProvider");
  }

  return useStore(hotelStoreContext, selector);
};
